import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class FrameAgreementService extends CrudService {
  constructor() {
    super('frameAgreements')
  }

  uploadFrameAgreement = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }
}

export default FrameAgreementService
